import { type User } from '../../types/user';
import { USER_STATUS, USER_ROLE, DISPLAY_TO_ROLE } from '../../constants';
import type { RowData } from '../../components/table';

export const selectRelevantRole = (roles: string[]): string => {
  return roles.includes(DISPLAY_TO_ROLE.Administrator)
    ? USER_ROLE.ACCOUNT_ADMIN
    : roles.includes(DISPLAY_TO_ROLE.Agent)
    ? USER_ROLE.AGENT
    : '-';
};

export const convertGetAgentsAndAccountAdminsResponseToTableRowData = (
  response: User[],
): RowData[] => {
  return response.map((item, index) => {
    const { id, userName, email, active, roles } = item;
    const status = active ? USER_STATUS.ACTIVE : USER_STATUS.INACTIVE;
    const role = selectRelevantRole(roles);
    const linkTo = `/users/${id}`;
    return {
      key: index,
      values: [userName, email, status, role],
      linkTo,
    };
  });
};
